import { render, staticRenderFns } from "./BooksUsage.vue?vue&type=template&id=af386292&"
import script from "./BooksUsage.vue?vue&type=script&lang=js&"
export * from "./BooksUsage.vue?vue&type=script&lang=js&"
import style0 from "./BooksUsage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports